import { SyntheticEvent, useState } from 'react';
import { usePermissions } from '../../../hooks/usePermissions';
import { useGetExpenseCategories } from '../api/useGetExpenseCategories';
import { useGetExpenses } from '../api/useGetExpenses';

export type AccountingTab = 'breakdown' | 'category' | 'comparison';

export function useAccountingPage() {
  const { isAdmin } = usePermissions();
  const [tab, setTab] = useState<AccountingTab>('breakdown');
  const [isCategoryFormOpen, setIsCategoryFormOpen] = useState(false);

  const categoriesQuery = useGetExpenseCategories();
  const categories = categoriesQuery.data ?? [];
  const expensesQuery = useGetExpenses(categories.map((category) => category.id));

  const isLoading = categoriesQuery.isPending || (categories.length > 0 && expensesQuery.isPending);
  const isError = categoriesQuery.isError || expensesQuery.isError;

  function handleTabChange(_event: SyntheticEvent, value: AccountingTab) {
    setTab(value);
  }

  function handleRetry() {
    categoriesQuery.refetch();
    expensesQuery.refetch();
  }

  return {
    isAdmin,
    tab,
    categories,
    expenses: expensesQuery.data ?? [],
    isLoading,
    isError,
    isCategoryFormOpen,
    handleTabChange,
    handleRetry,
    handleOpenCategoryForm: () => setIsCategoryFormOpen(true),
    handleCloseCategoryForm: () => setIsCategoryFormOpen(false),
  };
}
